(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/pages/terms/terms.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/pages/terms/terms.js');

'use strict';

const _svs$termsIntegrity$s = svs.termsIntegrity.sharedComponents,
  Footer = _svs$termsIntegrity$s.Footer,
  MainPage = _svs$termsIntegrity$s.MainPage,
  TopMenu = _svs$termsIntegrity$s.TopMenu;
const useGetCmsDataFolder = svs.termsIntegrity.sharedComponents.useGetCmsDataFolder;
const DocList = svs.termsIntegrity.sharedComponents.DocList;
const Terms = () => {
  const termsFolderId = ReactRedux.useSelector(state => state.termsIntegrity.termsFolderId);
  const termsServiceFolderId = ReactRedux.useSelector(state => state.termsIntegrity.termsServiceFolderId);
  const _useGetCmsDataFolder = useGetCmsDataFolder(termsFolderId),
    doc1Data = _useGetCmsDataFolder.data,
    doc1Loading = _useGetCmsDataFolder.loading,
    doc1DataError = _useGetCmsDataFolder.dataError;
  const _useGetCmsDataFolder2 = useGetCmsDataFolder(termsServiceFolderId),
    doc2Data = _useGetCmsDataFolder2.data,
    doc2Loading = _useGetCmsDataFolder2.loading,
    doc2DataError = _useGetCmsDataFolder2.dataError;
  return React.createElement(React.Fragment, null, React.createElement(TopMenu, null), React.createElement(MainPage, null, React.createElement("h2", null, "Grundl\xE4ggande kundvillkor"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, doc1DataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), doc1Loading && React.createElement("div", null, "Laddar dokument..."), ' ', doc1Data && doc1Data.length > 0 && React.createElement(DocList, {
    docList: doc1Data
  })), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement("h2", null, "Tj\xE4nstespecifika kundvillkor"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, doc2DataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), doc2Loading && React.createElement("div", null, "Laddar dokument..."), doc2Data && doc2Data.length > 0 && React.createElement(DocList, {
    docList: doc2Data
  })))), React.createElement(Footer, null));
};
svs.termsIntegrity.terms.Terms = Terms;

 })(window);